import React from 'react';
import './TeamMemberCard.css';

const TeamMemberCard = ({ member, isTeamFull }) => {
  const classes = [
    'bts-member',
    member.isOwner ? (isTeamFull ? 'bts-member--leader-full' : 'bts-member--leader') : 'bts-member--member',
    member.isCurrentUser ? 'bts-member--current' : '',
    member.isNewMember ? 'bts-member--x2' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {member.isNewMember && (
        <div className="bts-member__x2-top-badge">ยอดซื้อ x2</div>
      )}
      <div className="bts-member__avatar">
        {member.pictureUrl ? (
          <img src={member.pictureUrl} alt={member.name} className="bts-member__avatar-img" />
        ) : (
          <span>{member.avatar || '👤'}</span>
        )}
      </div>
      <div className="bts-member__info">
        <p className="bts-member__name">{member.name}</p>
        <p className="bts-member__points-num">{(member.points || 0).toLocaleString()}</p>
        <p className="bts-member__points-unit">คะแนน</p>
      </div>
      <div className="bts-member__badges">
        {member.isOwner && <span className="bts-member__leader-badge">หัวหน้าทีม</span>}
        {!member.isOwner && !member.isNewMember && <span className="bts-member__role-badge">ผู้ร่วมทีม</span>}
        {member.isCurrentUser && <span className="bts-member__you-badge">คุณ</span>}
        {member.isNewMember && <span className="bts-member__newmember-badge">NEW MEMBER</span>}
      </div>
    </div>
  );
};

export default TeamMemberCard;
